import { render, staticRenderFns } from "./AlarmCenterReferral.vue?vue&type=template&id=6bcbc384&scoped=true&"
import script from "./AlarmCenterReferral.vue?vue&type=script&lang=js&"
export * from "./AlarmCenterReferral.vue?vue&type=script&lang=js&"
import style0 from "./AlarmCenterReferral.vue?vue&type=style&index=0&id=6bcbc384&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcbc384",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VImg } from 'vuetify/lib/components/VImg';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCardActions,VCol,VContainer,VForm,VImg,VRow,VTextField})
